import * as React from 'react';

var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgUserCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a8.963 8.963 0 003.937-.904A9.15 9.15 0 0112 21zm5.277-1.709a4.34 4.34 0 00.349-.291v-1.189A4.001 4.001 0 0014 15.5h-4a4 4 0 00-3.626 2.311V19c.092.087.208.185.347.29a9 9 0 1110.557.002zm-9.21.806A9.151 9.151 0 0012 21a8.965 8.965 0 01-3.934-.903zM12 13.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "currentColor"
  })));
}

export { SvgUserCircleSolid as ReactComponent };
